import { useQuery } from '@tanstack/react-query';

import { MonitoringHealthComponentDetail } from 'src/features/monitoring/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/monitoring/health/components/:componentId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    componentId: string;
}

const queryFn = ({ parkingId, componentId }: DTO): Promise<MonitoringHealthComponentDetail> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, componentId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload.componentId],
        queryFn: async () => await queryFn(payload),
        // WS HEALTH_STATUS_UPDATED invalidates this query on real changes, so a
        // long stale window avoids redundant refetches when the user opens/closes
        // hover cards in quick succession.
        staleTime: 5 * 60 * 1000,
        ...config,
    });

export { RESOURCE as GET_MONITORING_HEALTH_COMPONENT_RESOURCE, useQueryHook as useGetMonitoringHealthComponent };
